import {
  SET_Liablity_INFORMATION,
  SET_SELECTED_Liablity_INFORMATION,
  SET_Liablity_TYPE_INFORMATION,
  SET_Liablity_ENTITY_INFORMATION,
  SET_ICE_API_RESPONSE,
  SET_LOAN_CHART_MODEL,
  SET_COMPARE_LOAN_INFO,
  SET_ICE_PROJECTION_MODEL,
} from "../../../helpers/vuex-constants";
export default {
  [SET_Liablity_INFORMATION](state, payload) {
    state.loandata = payload;
  },
  [SET_SELECTED_Liablity_INFORMATION](state, payload) {
    state.selectedLoan = payload;
  },
  [SET_Liablity_TYPE_INFORMATION](state, payload) {
    state.loanType = payload;
  },
  [SET_Liablity_ENTITY_INFORMATION](state, payload) {
    state.loanEntitiesInfo = payload;
  },
  [SET_ICE_PROJECTION_MODEL](state, payload) {
    state.iceProjectionModel = payload;
  },

  [SET_ICE_API_RESPONSE](state, payload) {
    state.iceAPIResponse = payload;
  },
  [SET_LOAN_CHART_MODEL](state, payload) {
    state.loanInput = payload;
  },
  [SET_COMPARE_LOAN_INFO](state, payload) {
    state.compareLoans = payload;
  },
};
